import { transient, autoinject } from "aurelia-framework";

@autoinject
@transient()
export class VetOverviewCoachmark {

    public group: string = 'vet-overview-coachmark';
}